export default "__VITE_ASSET__CiFlueSs__"